var map = {
	"./": 368,
	"./birds.mp3": 559,
	"./boat.mp3": 948,
	"./city.mp3": 773,
	"./coffee-shop.mp3": 821,
	"./fireplace.mp3": 578,
	"./index": 368,
	"./index.ts": 368,
	"./pink-noise.mp3": 972,
	"./rain.mp3": 138,
	"./storm.mp3": 858,
	"./stream.mp3": 692,
	"./summer-night.mp3": 872,
	"./train.mp3": 918,
	"./waves.mp3": 80,
	"./white-noise.mp3": 15,
	"./wind.mp3": 163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 743;